/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
  AggregateItemResponse,
  AggregateItemResponseFromJSON,
  CatalogItem,
  CatalogItemFromJSON,
  Complex,
  ComplexFromJSON,
  House,
  HouseFromJSON,
  InlineResponse20010,
  InlineResponse20010FromJSON,
  InlineResponse20011,
  InlineResponse20011FromJSON,
  InlineResponse2009,
  InlineResponse2009FromJSON,
  StageResponse,
  StageResponseFromJSON,
} from '../models';

export interface CatalogV1ComplexListRequest {
  id?: Array<number>;
  type?: string;
  search?: string;
  ordering?: string;
  limit?: number;
  offset?: number;
}

export interface CatalogV1ComplexReadRequest {
  id: number;
}

export interface CatalogV1HouseListRequest {
  id?: Array<number>;
  complex?: Array<number>;
  type?: Array<string>;
  number?: string;
  facing?: string;
  material?: string;
  buildingState?: string;
  search?: string;
  ordering?: string;
  limit?: number;
  offset?: number;
}

export interface CatalogV1HouseReadRequest {
  id: number;
}

export interface CatalogV1ItemAggregateListRequest {
  complex?: Array<number>;
  type?: Array<string>;
  status?: Array<string>;
  priceMin?: number;
  priceMax?: number;
  areaMax?: number;
  areaMin?: number;
  rooms?: Array<string>;
  dateComplete?: Array<string>;
  floorExclude?: CatalogV1ItemAggregateListFloorExcludeEnum;
  floorMin?: number;
  floorMax?: number;
  search?: string;
  ordering?: string;
}

export interface CatalogV1ItemListRequest {
  id?: Array<number>;
  complex?: Array<number>;
  house?: Array<number>;
  type?: Array<string>;
  priceMin?: number;
  priceMax?: number;
  areaMax?: number;
  areaMin?: number;
  rooms?: Array<string>;
  dateComplete?: Array<string>;
  floorExclude?: CatalogV1ItemListFloorExcludeEnum;
  pbObject?: string;
  status?: Array<string>;
  floorMin?: number;
  floorMax?: number;
  ordering?: CatalogV1ItemListOrderingEnum;
  limit?: number;
  offset?: number;
}

export interface CatalogV1ItemMyListRequest {
  building_state: string;
}

export interface CatalogV1ItemReadRequest {
  id: number;
}

export interface CatalogV1StageListRequest {
  house: string;
  startDate?: string;
  endDate?: string;
  completed?: string;
  search?: string;
  ordering?: string;
  limit?: number;
  offset?: number;
}

export interface DocumentDownloadRequest {
  uuid: string;
  name: string;
  ext: string;
}

/**
 *
 */
export class CatalogApi extends runtime.BaseAPI {
  /**
   */
  async catalogV1ComplexListRaw(
    requestParameters: CatalogV1ComplexListRequest
  ): Promise<runtime.ApiResponse<InlineResponse2009>> {
    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.id) {
      queryParameters['id'] = requestParameters.id.join(runtime.COLLECTION_FORMATS['csv']);
    }

    if (requestParameters.type !== undefined) {
      queryParameters['type'] = requestParameters.type;
    }

    if (requestParameters.search !== undefined) {
      queryParameters['search'] = requestParameters.search;
    }

    if (requestParameters.ordering !== undefined) {
      queryParameters['ordering'] = requestParameters.ordering;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters['limit'] = requestParameters.limit;
    }

    if (requestParameters.offset !== undefined) {
      queryParameters['offset'] = requestParameters.offset;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/catalog/v1/complex/`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => InlineResponse2009FromJSON(jsonValue));
  }

  /**
   */
  async catalogV1ComplexList(requestParameters: CatalogV1ComplexListRequest): Promise<InlineResponse2009> {
    const response = await this.catalogV1ComplexListRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async catalogV1ComplexReadRaw(requestParameters: CatalogV1ComplexReadRequest): Promise<runtime.ApiResponse<Complex>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling catalogV1ComplexRead.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/catalog/v1/complex/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => ComplexFromJSON(jsonValue));
  }

  /**
   */
  async catalogV1ComplexRead(requestParameters: CatalogV1ComplexReadRequest): Promise<Complex> {
    const response = await this.catalogV1ComplexReadRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async catalogV1HouseListRaw(
    requestParameters: CatalogV1HouseListRequest
  ): Promise<runtime.ApiResponse<InlineResponse20010>> {
    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.id) {
      queryParameters['id'] = requestParameters.id.join(runtime.COLLECTION_FORMATS['csv']);
    }

    if (requestParameters.complex) {
      queryParameters['complex'] = requestParameters.complex.join(runtime.COLLECTION_FORMATS['csv']);
    }

    if (requestParameters.type) {
      queryParameters['type'] = requestParameters.type.join(runtime.COLLECTION_FORMATS['csv']);
    }

    if (requestParameters.number !== undefined) {
      queryParameters['number'] = requestParameters.number;
    }

    if (requestParameters.facing !== undefined) {
      queryParameters['facing'] = requestParameters.facing;
    }

    if (requestParameters.material !== undefined) {
      queryParameters['material'] = requestParameters.material;
    }

    if (requestParameters.buildingState !== undefined) {
      queryParameters['building_state'] = requestParameters.buildingState;
    }

    if (requestParameters.search !== undefined) {
      queryParameters['search'] = requestParameters.search;
    }

    if (requestParameters.ordering !== undefined) {
      queryParameters['ordering'] = requestParameters.ordering;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters['limit'] = requestParameters.limit;
    }

    if (requestParameters.offset !== undefined) {
      queryParameters['offset'] = requestParameters.offset;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/catalog/v1/house/`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => InlineResponse20010FromJSON(jsonValue));
  }

  /**
   */
  async catalogV1HouseList(requestParameters: CatalogV1HouseListRequest): Promise<InlineResponse20010> {
    const response = await this.catalogV1HouseListRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async catalogV1HouseReadRaw(requestParameters: CatalogV1HouseReadRequest): Promise<runtime.ApiResponse<House>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling catalogV1HouseRead.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/catalog/v1/house/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => HouseFromJSON(jsonValue));
  }

  /**
   */
  async catalogV1HouseRead(requestParameters: CatalogV1HouseReadRequest): Promise<House> {
    const response = await this.catalogV1HouseReadRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async catalogV1ItemAggregateListRaw(
    requestParameters: CatalogV1ItemAggregateListRequest
  ): Promise<runtime.ApiResponse<AggregateItemResponse>> {
    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.complex) {
      queryParameters['complex'] = requestParameters.complex.join(runtime.COLLECTION_FORMATS['csv']);
    }

    if (requestParameters.type) {
      queryParameters['type'] = requestParameters.type.join(runtime.COLLECTION_FORMATS['csv']);
    }

    if (requestParameters.status) {
      queryParameters['status'] = requestParameters.status.join(runtime.COLLECTION_FORMATS['csv']);
    }

    if (requestParameters.priceMin !== undefined) {
      queryParameters['price_min'] = requestParameters.priceMin;
    }

    if (requestParameters.priceMax !== undefined) {
      queryParameters['price_max'] = requestParameters.priceMax;
    }

    if (requestParameters.areaMax !== undefined) {
      queryParameters['area_max'] = requestParameters.areaMax;
    }

    if (requestParameters.areaMin !== undefined) {
      queryParameters['area_min'] = requestParameters.areaMin;
    }

    if (requestParameters.rooms) {
      queryParameters['rooms'] = requestParameters.rooms.join(runtime.COLLECTION_FORMATS['csv']);
    }

    if (requestParameters.dateComplete) {
      queryParameters['date_complete'] = requestParameters.dateComplete.join(runtime.COLLECTION_FORMATS['csv']);
    }

    if (requestParameters.floorExclude !== undefined) {
      queryParameters['floor_exclude'] = requestParameters.floorExclude;
    }

    if (requestParameters.floorMin !== undefined) {
      queryParameters['floor_min'] = requestParameters.floorMin;
    }

    if (requestParameters.floorMax !== undefined) {
      queryParameters['floor_max'] = requestParameters.floorMax;
    }

    if (requestParameters.search !== undefined) {
      queryParameters['search'] = requestParameters.search;
    }

    if (requestParameters.ordering !== undefined) {
      queryParameters['ordering'] = requestParameters.ordering;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/catalog/v1/item/aggregate/`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => AggregateItemResponseFromJSON(jsonValue));
  }

  /**
   */
  async catalogV1ItemAggregateList(
    requestParameters: CatalogV1ItemAggregateListRequest
  ): Promise<AggregateItemResponse> {
    const response = await this.catalogV1ItemAggregateListRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async catalogV1ItemListRaw(
    requestParameters: CatalogV1ItemListRequest
  ): Promise<runtime.ApiResponse<InlineResponse20011>> {
    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.id) {
      queryParameters['id'] = requestParameters.id.join(runtime.COLLECTION_FORMATS['csv']);
    }

    if (requestParameters.complex) {
      queryParameters['complex'] = requestParameters.complex.join(runtime.COLLECTION_FORMATS['csv']);
    }

    if (requestParameters.house) {
      queryParameters['house'] = requestParameters.house.join(runtime.COLLECTION_FORMATS['csv']);
    }

    if (requestParameters.type) {
      queryParameters['type'] = requestParameters.type.join(runtime.COLLECTION_FORMATS['csv']);
    }

    if (requestParameters.priceMin !== undefined) {
      queryParameters['price_min'] = requestParameters.priceMin;
    }

    if (requestParameters.priceMax !== undefined) {
      queryParameters['price_max'] = requestParameters.priceMax;
    }

    if (requestParameters.areaMax !== undefined) {
      queryParameters['area_max'] = requestParameters.areaMax;
    }

    if (requestParameters.areaMin !== undefined) {
      queryParameters['area_min'] = requestParameters.areaMin;
    }

    if (requestParameters.rooms) {
      queryParameters['rooms'] = requestParameters.rooms.join(runtime.COLLECTION_FORMATS['csv']);
    }

    if (requestParameters.dateComplete) {
      queryParameters['date_complete'] = requestParameters.dateComplete.join(runtime.COLLECTION_FORMATS['csv']);
    }

    if (requestParameters.floorExclude !== undefined) {
      queryParameters['floor_exclude'] = requestParameters.floorExclude;
    }

    if (requestParameters.pbObject !== undefined) {
      queryParameters['pb_object'] = requestParameters.pbObject;
    }

    if (requestParameters.status) {
      queryParameters['status'] = requestParameters.status.join(runtime.COLLECTION_FORMATS['csv']);
    }

    if (requestParameters.floorMin !== undefined) {
      queryParameters['floor_min'] = requestParameters.floorMin;
    }

    if (requestParameters.floorMax !== undefined) {
      queryParameters['floor_max'] = requestParameters.floorMax;
    }

    if (requestParameters.ordering !== undefined) {
      queryParameters['ordering'] = requestParameters.ordering;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters['limit'] = requestParameters.limit;
    }

    if (requestParameters.offset !== undefined) {
      queryParameters['offset'] = requestParameters.offset;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/catalog/v1/item/`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => InlineResponse20011FromJSON(jsonValue));
  }

  /**
   */
  async catalogV1ItemList(requestParameters: CatalogV1ItemListRequest): Promise<InlineResponse20011> {
    const response = await this.catalogV1ItemListRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async catalogV1ItemMyListRaw(
    requestParameters: CatalogV1ItemMyListRequest
  ): Promise<runtime.ApiResponse<Array<CatalogItem>>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters && requestParameters.building_state && requestParameters.building_state !== 'all') {
      queryParameters['building_state'] = requestParameters.building_state;
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/catalog/v1/item/my/`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => jsonValue.map(CatalogItemFromJSON));
  }

  /**
   */
  async catalogV1ItemMyList(requestParameters: CatalogV1ItemMyListRequest): Promise<Array<CatalogItem>> {
    const response = await this.catalogV1ItemMyListRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async catalogV1ItemReadRaw(requestParameters: CatalogV1ItemReadRequest): Promise<runtime.ApiResponse<CatalogItem>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling catalogV1ItemRead.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/catalog/v1/item/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => CatalogItemFromJSON(jsonValue));
  }

  /**
   */
  async catalogV1ItemRead(requestParameters: CatalogV1ItemReadRequest): Promise<CatalogItem> {
    const response = await this.catalogV1ItemReadRaw(requestParameters);
    return await response.value();
  }

  /**
   * Этапы строительства
   */
  async catalogV1StageListRaw(
    requestParameters: CatalogV1StageListRequest
  ): Promise<runtime.ApiResponse<StageResponse>> {
    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.house !== undefined) {
      queryParameters['house'] = requestParameters.house;
    }

    if (requestParameters.startDate !== undefined) {
      queryParameters['start_date'] = requestParameters.startDate;
    }

    if (requestParameters.endDate !== undefined) {
      queryParameters['end_date'] = requestParameters.endDate;
    }

    if (requestParameters.completed !== undefined) {
      queryParameters['completed'] = requestParameters.completed;
    }

    if (requestParameters.search !== undefined) {
      queryParameters['search'] = requestParameters.search;
    }

    if (requestParameters.ordering !== undefined) {
      queryParameters['ordering'] = requestParameters.ordering;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters['limit'] = requestParameters.limit;
    }

    if (requestParameters.offset !== undefined) {
      queryParameters['offset'] = requestParameters.offset;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/catalog/v1/stage/`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => StageResponseFromJSON(jsonValue));
  }

  /**
   * Этапы строительства
   */
  async catalogV1StageList(requestParameters: CatalogV1StageListRequest): Promise<StageResponse> {
    const response = await this.catalogV1StageListRaw(requestParameters);
    return await response.value();
  }

  async downloadObjectDocsRaw(requestParameters: DocumentDownloadRequest): Promise<runtime.ApiResponse<Blob>> {
    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/catalog/v1/item/get-secret-file/${requestParameters.uuid}`,
      method: 'GET',
      headers: headerParameters,
    });

    return new runtime.BlobApiResponse(response);
  }

  async downloadObjectDocs(requestParameters: DocumentDownloadRequest): Promise<Blob> {
    const response = await this.downloadObjectDocsRaw(requestParameters);

    return await response.value();
  }
}

/**
 * @export
 * @enum {string}
 */
export enum CatalogV1ItemAggregateListFloorExcludeEnum {
  First = 'first',
  Last = 'last',
}
/**
 * @export
 * @enum {string}
 */
export enum CatalogV1ItemListFloorExcludeEnum {
  First = 'first',
  Last = 'last',
}
/**
 * @export
 * @enum {string}
 */
export enum CatalogV1ItemListOrderingEnum {
  Id = 'id',
  Price = 'price',
  AreaTotal = 'area_total',
  RoomsAmount = 'rooms_amount',
  Floor = 'floor',
}
